import type { BlogPost } from "./blog";

export const BLOG_EVENTS_PART4: BlogPost[] = [
  {
    "slug": "svadba-restoran-spb-organizatsiya",
    "title": "Свадьба в ресторане Санкт-Петербурга: организация",
    "metaTitle": "Свадьба в ресторане СПб — организация 2026 | Паруса",
    "metaDescription": "Как организовать свадьбу в ресторане Санкт-Петербурга: пошаговый план, советы, что учесть.",
    "keywords": "свадьба ресторан санкт-петербург, организация свадьбы ресторан спб, свадьба в ресторане петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 8,
    "image": "/photos/view_sunset.webp",
    "lead": "Свадьба в ресторане — самый популярный формат торжества. Разберём, как спланировать её от А до Я, чтобы всё прошло гладко.",
    "sections": [
      {
        "heading": "Пошаговый план организации",
        "body": "6–12 месяцев до: выбор ресторана и дата. 3–6 месяцев: меню, флорист, фотограф, ведущий, музыканты. 1–3 месяца: финальный состав гостей, рассадка, детали программы. 2 недели: подтверждение всего, финальный расчёт гостей. За день: передать ресторану декор, финальный брифинг с менеджером.",
        "list": [
          "12 мес.: ресторан + дата — приоритет",
          "6 мес.: команда (фотограф, флорист, ведущий)",
          "3 мес.: финальный состав гостей",
          "2 нед.: подтверждение деталей"
        ]
      },
      {
        "heading": "Что важно при выборе ресторана для свадьбы",
        "body": "Вместимость: с запасом 10–15% от числа гостей. Опыт свадеб: сколько уже проведено, есть ли менеджер. Дегустация: обязательно попробуйте банкетное меню заранее. Декор: что можно принести своё, что запрещено. Внешний вид: фотогеничность зала и вид из окна.",
        "highlight": "Правило: посетите ресторан в вечернее время работы — именно тогда увидите реальную атмосферу. Дневной визит при пустом зале не показателен."
      },
      {
        "heading": "Свадьба в «Парусах на крыше»",
        "body": "«Паруса» (ул. Марата, 5, 6 этаж) — 15+ лет свадеб. Зал до 300 гостей, панорама Петербурга, банкетное меню от 2 500 ₽/чел, менеджер мероприятий, живая музыка. Телефон: +7 (812) 991-10-90. Читайте о <a href='/svadba' class='underline text-accent'>свадьбе в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Узнать о свадьбе в «Парусах»", "href": "/svadba" }
  },
  {
    "slug": "svadebnyy-banket-krysha-peterburg",
    "title": "Свадебный банкет на крыше в Петербурге",
    "metaTitle": "Свадебный банкет на крыше Петербург 2026 | Паруса на крыше",
    "metaDescription": "Свадебный банкет на крыше в Санкт-Петербурге: уникальный формат для незабываемой свадьбы.",
    "keywords": "свадебный банкет на крыше петербург, свадьба крыша спб, банкет на крыше петербург свадьба",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Свадьба на крыше Петербурга — нестандартный, запоминающийся формат. Вид на город, открытое небо, купола соборов на горизонте.",
    "sections": [
      {
        "heading": "Формат свадьбы на крыше",
        "body": "«Крыша» в ресторанном контексте — это либо открытая терраса на верхнем этаже, либо ресторан с максимальным видом через панорамные окна. «Паруса» дают оба варианта: летом открытая терраса, круглый год — зал с 300° видом. Это принципиально другая атмосфера свадьбы: не закрытый банкетный зал, а ощущение простора.",
        "list": [
          "Открытая терраса: летом — особая романтика",
          "Панорамный зал: круглый год",
          "Вид: Казанский собор, крыши, горизонт",
          "Атмосфера: не замкнутый зал, а простор"
        ]
      },
      {
        "heading": "Организация свадьбы на крыше «Парусов»",
        "body": "«Паруса» (ул. Марата, 5, 6 этаж) приняли сотни свадеб. Летняя терраса для фото и фуршета. Закрытый зал для торжественного ужина. До 300 гостей. Банкетное меню от 2 500 ₽/чел. Телефон: +7 (812) 991-10-90. Читайте о <a href='/svadba' class='underline text-accent'>свадебных возможностях</a>."
      }
    ],
    "cta": { "text": "Спланировать свадьбу", "href": "/svadba" }
  },
  {
    "slug": "svadba-30-chelovek-restoran-spb",
    "title": "Свадьба на 30 человек в ресторане СПб",
    "metaTitle": "Свадьба на 30 человек ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Как организовать свадьбу на 30 человек в ресторане Санкт-Петербурга: залы, меню, цены.",
    "keywords": "свадьба 30 человек ресторан спб, свадьба небольшая ресторан петербург, свадьба 30 гостей спб",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Свадьба на 30 человек — самый камерный из «больших» форматов. Только близкие, максимальное внимание каждому гостю. Разберём, как это организовать в Петербурге.",
    "sections": [
      {
        "heading": "Особенности камерной свадьбы",
        "body": "30 человек — это семья и лучшие друзья. Не нужна большая сцена и профессиональный ведущий (можно, но не обязательно). Достаточно хорошего зала на 30–40 мест, правильного меню и живой музыки для атмосферы. Преимущества: каждый гость получает внимание, программа может быть максимально личной.",
        "list": [
          "30 человек: только близкие",
          "Зал 40–50 м²: комфортный размер",
          "Ведущий: необязателен для маленькой компании",
          "Живая музыка: создаёт атмосферу без программы"
        ]
      },
      {
        "heading": "«Паруса» для свадьбы на 30",
        "body": "Для 30 гостей в «Парусах» (ул. Марата, 5) выделяется приватная зона с видом. Банкетное меню от 2 500 ₽/чел, живая музыка по расписанию. Для 30 гостей — примерно 75 000–100 000 ₽ + алкоголь. Панорама Петербурга создаёт атмосферу без дополнительных декораций. Читайте о <a href='/svadba' class='underline text-accent'>свадьбе в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Спланировать свадьбу на 30 человек", "href": "/svadba" }
  },
  {
    "slug": "svadba-50-chelovek-restoran-peterburg",
    "title": "Свадьба на 50 человек в ресторане Петербурга",
    "metaTitle": "Свадьба на 50 человек ресторан Петербург 2026 | Паруса",
    "metaDescription": "Организация свадьбы на 50 человек в ресторане Санкт-Петербурга: залы, цены, формат.",
    "keywords": "свадьба 50 человек ресторан петербург, свадьба 50 гостей спб, средняя свадьба ресторан петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "50 гостей — средняя свадьба. Достаточно большая для полноценной программы, достаточно камерная для особой атмосферы. Разберём логистику.",
    "sections": [
      {
        "heading": "Организация свадьбы на 50",
        "body": "50 гостей — уже нужна продуманная рассадка, чёткая программа и ведущий. Зал: не менее 80–100 м² с местом для танцев (если планируется). Меню: банкетное, с несколькими переменами. Музыка: живая группа или ведущий с музыкальной системой. Фотограф: обязателен. Видеограф: желателен.",
        "list": [
          "Зал 80–100 м²: комфортно",
          "Ведущий: обязателен для 50+",
          "Рассадка: продумайте заранее",
          "Фотограф: без вариантов"
        ]
      },
      {
        "heading": "«Паруса» на 50 гостей",
        "body": "Зал «Парусов» (ул. Марата, 5) легко вмещает 50 гостей с местом для танцев. Банкетное меню от 2 500 ₽/чел = от 125 000 ₽ за еду. Алкоголь отдельно. Менеджер мероприятий включён. Рейтинг 5,0. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Спланировать свадьбу на 50 человек", "href": "/svadba" }
  },
  {
    "slug": "svadba-vid-na-peterburg-rестораны",
    "title": "Свадьба с видом на Петербург: рестораны",
    "metaTitle": "Свадьба с видом на Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны для свадьбы с видом на Санкт-Петербург: панорама, виды, особая атмосфера.",
    "keywords": "свадьба вид на петербург, свадьба панорамный вид спб, свадьба с видом на город петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Свадьба с видом на Петербург — это когда город становится частью торжества. Купола, крыши, горизонт — лучшее свадебное «оформление» зала.",
    "sections": [
      {
        "heading": "Почему вид важен на свадьбе",
        "body": "Место задаёт тон праздника. Обычный банкетный зал требует дорогого декора для создания атмосферы. Зал с видом на Петербург — атмосфера создаётся сама. Меньше денег на флористику, больше — на кухню и музыку. Каждая фотография с видом за окном — открытка.",
        "list": [
          "Вид заменяет дорогой декор",
          "Фотографии: каждый кадр с видом",
          "Атмосфера: создаётся сама собой",
          "Бюджет: экономия на декоре"
        ]
      },
      {
        "heading": "«Паруса» — лучший вид для свадьбы",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) — уникальная точка для свадьбы в Петербурге. 300° панорама: Казанский собор, крыши центра, горизонт над Невой. Работают с 2009 года, проведено сотни свадеб. Рейтинг 5,0. Читайте о <a href='/svadba' class='underline text-accent'>свадьбе в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Спланировать свадьбу с видом", "href": "/svadba" }
  },
  {
    "slug": "yubiley-svadby-25-let-restoran-spb",
    "title": "Юбилей свадьбы 25 лет: где отметить в СПб",
    "metaTitle": "Юбилей свадьбы 25 лет СПб 2026 | Паруса на крыше",
    "metaDescription": "Где отметить серебряную свадьбу (25 лет) в ресторане Санкт-Петербурга: форматы и идеи.",
    "keywords": "юбилей свадьбы 25 лет спб, серебряная свадьба ресторан петербург, 25 лет свадьба где отметить",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "25 лет вместе — серебряная свадьба. Особая дата, которую стоит отметить с той же торжественностью, что и настоящую свадьбу.",
    "sections": [
      {
        "heading": "Форматы серебряной свадьбы",
        "body": "Камерный ужин для пары: только двое — романтический ужин в лучшем ресторане. Семейный ужин: дети, внуки, ближайшие родственники. Расширенный банкет: как настоящая свадьба 25 лет спустя — гости, программа, живая музыка. Каждый формат хорош — главное соответствие парам.",
        "list": [
          "Ужин для двоих: максимально личное",
          "Семейный ужин: близкие родственники",
          "Банкет: как настоящая свадьба",
          "Символика: серебро в декоре"
        ]
      },
      {
        "heading": "«Паруса» для серебряной свадьбы",
        "body": "«Паруса» (ул. Марата, 5) — правильное место для серебряной свадьбы в любом формате. Для двоих: столик у окна с видом, шампанское. Для банкета: зал до 300 гостей, меню от 2 500 ₽/чел. Скидка 20% для именинников. Рейтинг 5,0. Читайте о <a href='/svadba' class='underline text-accent'>свадебных мероприятиях</a>."
      }
    ],
    "cta": { "text": "Отметить серебряную свадьбу", "href": "/svadba" }
  },
  {
    "slug": "godovshchina-otnosheniy-restoran-spb",
    "title": "Ресторан для годовщины отношений в СПб",
    "metaTitle": "Ресторан годовщина отношений СПб 2026 | Паруса на крыше",
    "metaDescription": "Где отметить годовщину отношений в ресторане Санкт-Петербурга: лучшие места для особого вечера.",
    "keywords": "ресторан годовщина отношений спб, годовщина ресторан петербург, ресторан отношения дата петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Годовщина отношений — повод для особого вечера. Не просто ужин, а вечер, который напомнит, почему вы вместе.",
    "sections": [
      {
        "heading": "Как сделать годовщину особенной",
        "body": "Не повторяйте прошлый раз. Каждая годовщина — новое место или новый формат. Возвращение туда, где познакомились — классика. Место, где ещё не были вместе — открытие. Что точно работает: особый вид, живая музыка, место, которое создаёт «мы здесь единственные» ощущение.",
        "list": [
          "Новое место: годовщина = открытие",
          "Вид: что-то запоминающееся",
          "Живая музыка: персонализирует вечер",
          "Особые детали: цветы, шампанское"
        ]
      },
      {
        "heading": "«Паруса» для годовщины",
        "body": "«Паруса» (ул. Марата, 5, 6 этаж) — место, которое создаёт «мы здесь единственные» ощущение при первом же взгляде с лифта. Вид на Петербург, живая музыка, авторская кухня. Скидка 20% если дата совпадает с днём рождения одного из пары. Рейтинг 5,0. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a>."
      }
    ],
    "cta": { "text": "Отметить годовщину", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "uzhin-pri-svechakh-restoran-spb",
    "title": "Ужин при свечах в ресторане СПб: где найти",
    "metaTitle": "Ужин при свечах ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с ужином при свечах в Санкт-Петербурге: атмосфера, лучшие места для романтики.",
    "keywords": "ужин при свечах ресторан спб, ужин со свечами петербург, романтический ужин свечи ресторан",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Ужин при свечах — классика романтики. Мягкий свет создаёт особое ощущение: время замедляется, внимание сосредоточено на собеседнике.",
    "sections": [
      {
        "heading": "Почему свечи работают",
        "body": "Свет свечи — тёплый, нестабильный, живой. Он создаёт ощущение уюта и интимности. Психологически: при тёплом свете люди чувствуют себя более расслабленными и открытыми. Лица при свечах выглядят красивее. Практически: если вы хотите свечи — уточните при бронировании. Не все рестораны используют их постоянно.",
        "list": [
          "Тёплый свет: расслабляет и создаёт близость",
          "Живой огонь: динамичность, не статичный свет",
          "Уточните при бронировании: есть ли свечи",
          "Просьба о специальных свечах: заранее"
        ]
      },
      {
        "heading": "Свечи в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) используют свечи как часть вечернего оформления. Для особого повода — попросите при бронировании поставить свечи на столик. Это стандартная просьба, которую выполняют. Рейтинг 5,0. Тёплый свет + вид на ночной Петербург = идеальная романтическая атмосфера."
      }
    ],
    "cta": { "text": "Забронировать ужин при свечах", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "korporativ-na-20-chelovek-restoran-spb",
    "title": "Корпоратив на 20 человек в ресторане СПб",
    "metaTitle": "Корпоратив на 20 человек ресторан СПб 2026 | Паруса",
    "metaDescription": "Организация корпоратива на 20 человек в ресторане Санкт-Петербурга: форматы, цены, залы.",
    "keywords": "корпоратив 20 человек ресторан спб, корпоратив небольшой петербург, ресторан корпоратив 20 гостей",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Корпоратив на 20 человек — небольшой по меркам корпоративных мероприятий. Это камерный формат, где все знают друг друга. Разберём, как его организовать.",
    "sections": [
      {
        "heading": "Форматы для 20 человек",
        "body": "Выделенная зона в ресторане: хватит одного большого стола или нескольких круглых. Аренда малого зала: есть в некоторых ресторанах. Выкуп части ресторана: для 20 человек — необязательно. Для небольшого коллектива достаточно правильно расставленных столов с отдельным обслуживанием.",
        "list": [
          "Выделенная зона: достаточно для 20 человек",
          "Малый зал: если нужна полная приватность",
          "Бюджет: 2 500–4 500 ₽/чел = 50 000–90 000 ₽",
          "Ведущий: необязателен для маленькой команды"
        ]
      },
      {
        "heading": "Корпоратив на 20 в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) — для 20 человек легко организовать приватную зону с видом на Петербург. Банкетное меню от 2 500 ₽/чел = от 50 000 ₽ за еду. Живая музыка по расписанию. Рейтинг 5,0. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных возможностях</a>."
      }
    ],
    "cta": { "text": "Организовать корпоратив на 20", "href": "/korporativ" }
  },
  {
    "slug": "korporativ-na-50-chelovek-peterburg",
    "title": "Корпоратив на 50 человек в Петербурге: организация",
    "metaTitle": "Корпоратив на 50 человек Петербург 2026 | Паруса на крыше",
    "metaDescription": "Как организовать корпоратив на 50 человек в Петербурге: залы, меню, программа.",
    "keywords": "корпоратив 50 человек петербург, корпоратив 50 гостей спб, ресторан корпоратив 50 людей",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Корпоратив на 50 человек — средний формат, требующий полноценной организации: зал, программа, меню, обслуживание.",
    "sections": [
      {
        "heading": "Организация корпоратива на 50",
        "body": "50 человек — нужна чёткая программа, ведущий (минимум — кто-то из коллег), выделенный банкетный зал или выкуп ресторана. Бюджет: 3 000–5 000 ₽/чел = 150 000–250 000 ₽ полностью. Меню: банкетное с несколькими переменами. Алкоголь: рассчитайте заранее (1–1,5 л вина + 0,5 л крепкого на человека — стандарт).",
        "list": [
          "Банкетный зал: нужен выделенный",
          "Ведущий: обязателен для 50+",
          "Бюджет: 150 000–250 000 ₽ за вечер",
          "Алкоголь: планируйте заранее"
        ]
      },
      {
        "heading": "«Паруса» на 50 гостей",
        "body": "«Паруса» (ул. Марата, 5) — идеальный выбор для корпоратива на 50: банкетный зал с видом на Петербург, менеджер мероприятий, живая музыка. Банкетное меню от 2 500 ₽/чел. Телефон: +7 (812) 991-10-90. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных возможностях</a>."
      }
    ],
    "cta": { "text": "Организовать корпоратив на 50", "href": "/korporativ" }
  },
  {
    "slug": "korporativ-na-kryshe-peterburg",
    "title": "Корпоратив на крыше в Петербурге: идеи",
    "metaTitle": "Корпоратив на крыше Петербург 2026 | Паруса на крыше",
    "metaDescription": "Корпоратив на крыше в Санкт-Петербурге: уникальный формат с видом на город.",
    "keywords": "корпоратив на крыше петербург, корпоратив крыша спб, мероприятие крыша петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Корпоратив на крыше Петербурга — нестандартный формат. Вид на город работает на атмосферу без дополнительных декораций и программы.",
    "sections": [
      {
        "heading": "Почему крыша работает для корпоратива",
        "body": "Нестандартное место создаёт разговорный повод. Вид на город производит впечатление — сотрудники, которые не бывали в таком месте, запомнят его. «Вау-эффект» при входе — правильный старт корпоратива. Открытое небо летом — добавляет свежести и праздничности. Фото в соцсетях — все захотят сделать.",
        "list": [
          "Нестандартность: запоминается",
          "Вид: сам по себе создаёт атмосферу",
          "Летом: открытая терраса",
          "Фото: место для корпоративного контента"
        ]
      },
      {
        "heading": "Корпоратив на крыше в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5, 6 этаж) — стандарт жанра «корпоратив на крыше» в Петербурге. 15 лет опыта, зал до 300 гостей, летняя терраса, живая музыка. Банкетное меню от 2 500 ₽/чел. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных мероприятиях</a>."
      }
    ],
    "cta": { "text": "Организовать корпоратив на крыше", "href": "/korporativ" }
  },
  {
    "slug": "novogodniy-korporativ-restoran-spb-2026",
    "title": "Новогодний корпоратив в ресторане СПб 2026",
    "metaTitle": "Новогодний корпоратив ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Как организовать новогодний корпоратив в ресторане Санкт-Петербурга: советы, сроки, цены.",
    "keywords": "новогодний корпоратив ресторан спб, корпоратив новый год петербург, новогоднее мероприятие ресторан",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Новогодний корпоратив — главное корпоративное событие года. Разбираем, как его правильно организовать.",
    "sections": [
      {
        "heading": "Сроки и планирование",
        "body": "Начало планирования: сентябрь–октябрь. Лучшие рестораны центра закрыты на декабрь уже в октябре. Дата: 25–28 декабря — популярны (не слишком близко к 31-му). 10–18 декабря — меньше конкуренции. Формат: новогодняя программа с ведущим и шоу vs просто корпоративный ужин.",
        "list": [
          "Планировать в сентябре: лучшие рестораны уходят",
          "Дата: 25–28 декабря — пик спроса",
          "10–18 декабря: больше вариантов",
          "Бюджет: декабрь дороже на 20–30%"
        ]
      },
      {
        "heading": "«Паруса» на Новый год",
        "body": "«Паруса» (ул. Марата, 5) — популярны для новогодних корпоративов. Декабрьский Петербург с панорамой — иллюминация, снег на крышах, подсветка куполов. Атмосфера создаётся сама. Бронирование в сентябре–октябре. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных мероприятиях</a>."
      }
    ],
    "cta": { "text": "Забронировать новогодний корпоратив", "href": "/korporativ" }
  },
  {
    "slug": "letniy-korporativ-terrasa-spb",
    "title": "Летний корпоратив на террасе в СПб",
    "metaTitle": "Летний корпоратив на террасе СПб 2026 | Паруса на крыше",
    "metaDescription": "Летний корпоратив на открытой террасе в Санкт-Петербурге: форматы, места, организация.",
    "keywords": "летний корпоратив терраса спб, корпоратив открытый воздух петербург, летний тимбилдинг ресторан спб",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Летний корпоратив на открытой террасе — один из лучших форматов. Свежий воздух, белые ночи, неформальная атмосфера.",
    "sections": [
      {
        "heading": "Преимущества летнего корпоратива на террасе",
        "body": "Свежий воздух: снижает официальность, способствует общению. Белые ночи (июнь): ужин заканчивается при дневном свете — уникальный петербургский опыт. Неформально: летняя атмосфера подходит для тимбилдинга и неофициального общения. Фотогенично: фото с открытым небом и видом на город.",
        "list": [
          "Свежий воздух: неформальность",
          "Белые ночи: петербургская уникальность",
          "Тимбилдинг: летом органичнее",
          "Фото: открытое небо и вид на город"
        ]
      },
      {
        "heading": "Летняя терраса «Парусов»",
        "body": "Летняя терраса «Парусов» (ул. Марата, 5) открывается в мае. Корпоратив на открытой площадке с видом на Петербург в белые ночи — редкий формат. Бронируйте в апреле–мае: июньские даты уходят быстро. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративе в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Забронировать летний корпоратив", "href": "/korporativ" }
  },
  {
    "slug": "arenda-zala-korporativ-peterburg",
    "title": "Аренда зала для корпоратива в Петербурге",
    "metaTitle": "Аренда зала корпоратив Петербург 2026 | Паруса на крыше",
    "metaDescription": "Как арендовать зал для корпоратива в Санкт-Петербурге: варианты, цены, что включает аренда.",
    "keywords": "аренда зала корпоратив петербург, зал для корпоратива спб, аренда банкетного зала петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Аренда зала для корпоратива — основной вопрос при организации мероприятия. Разберём, что включает в себя «аренда» и как правильно подойти к переговорам с рестораном.",
    "sections": [
      {
        "heading": "Что включает аренда зала",
        "body": "Обычно при «аренде» ресторанного зала речь идёт не о плате за квадратные метры, а о минимальном гарантированном чеке (МГЧ). МГЧ = минимальная сумма, которую вы обязуетесь потратить на еду и напитки. Если потратите больше — отлично. Если меньше — разница не возвращается. Дополнительно могут начисляться: за технический райдер (проектор, микрофон), за организацию декора, иногда небольшая аренда в выходные.",
        "list": [
          "МГЧ: минимальная сумма на еду+напитки",
          "Технический райдер: проектор, микрофон — отдельно",
          "Декор: согласуйте что можно принести",
          "Аренда в чистом виде: редко, обычно МГЧ"
        ]
      },
      {
        "heading": "Аренда в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) работают по системе минимального гарантированного чека. Уточняйте МГЧ при переговорах. Банкетное меню от 2 500 ₽/чел. Для корпоратива на 50 гостей: МГЧ обычно 125 000–150 000 ₽ (еда) + алкоголь. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Узнать об аренде зала", "href": "/korporativ" }
  },
  {
    "slug": "korporativ-zimoy-peterburg-idei",
    "title": "Корпоратив зимой в Петербурге: лучшие места",
    "metaTitle": "Корпоратив зимой Петербург 2026 | Паруса на крыше",
    "metaDescription": "Где провести корпоратив зимой в Санкт-Петербурге: уютные места с праздничной атмосферой.",
    "keywords": "корпоратив зимой петербург, зимний корпоратив спб, корпоратив декабрь петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Зима — главный сезон корпоративов. Декабрь, январь, корпоратив по поводу Нового года — все хотят отметить. Как выбрать правильное место?",
    "sections": [
      {
        "heading": "Зимний корпоратив: что важно",
        "body": "Зима добавляет своё: иллюминация на улицах, снег, предпраздничное настроение. Ресторан с видом на зимний Петербург — особенно уместен именно зимой. Уют внутри vs зима снаружи — правильный контраст. Живая музыка и новогодний декор завершают атмосферу.",
        "list": [
          "Иллюминация за окнами: бесплатный декор",
          "Уют внутри vs холод снаружи: правильный контраст",
          "Новогодний декор: уточните у ресторана",
          "Живая музыка: зимой особенно уместна"
        ]
      },
      {
        "heading": "«Паруса» зимой",
        "body": "«Паруса» (ул. Марата, 5) зимой — тёплый зал, огни города за панорамными окнами, декабрьская иллюминация на крышах. Идеальная атмосфера для зимнего корпоратива. Бронируйте в октябре. Читайте о <a href='/korporativ' class='underline text-accent'>корпоративных возможностях</a>."
      }
    ],
    "cta": { "text": "Забронировать зимний корпоратив", "href": "/korporativ" }
  },
  {
    "slug": "vypusknoy-restoran-spb-organizatsiya",
    "title": "Выпускной в ресторане СПб: как организовать",
    "metaTitle": "Выпускной в ресторане СПб — организация 2026 | Паруса",
    "metaDescription": "Как организовать выпускной в ресторане Санкт-Петербурга: пошаговый план, цены, советы.",
    "keywords": "выпускной ресторан спб организовать, выпускной вечер ресторан петербург, организация выпускного ресторан",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Выпускной в ресторане — главная альтернатива традиционному школьному банкету. Как организовать его правильно?",
    "sections": [
      {
        "heading": "Пошаговый план выпускного",
        "body": "3–4 месяца до: выбор ресторана и дата (июнь занят — бронируйте рано). 1–2 месяца до: меню, ведущий, фотограф, декор. 2 недели до: финальный список, рассадка. День до: передать декор, фото для слайд-шоу. Важно: согласовать с родителями и классом формат и бюджет заранее.",
        "list": [
          "3–4 месяца до: ресторан и дата",
          "Июнь — пик: бронируйте рано",
          "Ведущий: обязателен для программы",
          "Фото/видео: сохранят воспоминания"
        ]
      },
      {
        "heading": "Выпускной в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) — правильный выбор для выпускного в июне: открытая терраса с белыми ночами, зал до 300 гостей, живая музыка. После банкета — пешком к набережной встречать рассвет. Банкетное меню от 2 500 ₽/чел. Читайте о <a href='/blog/vypusknoy-krysha-spb' class='underline text-accent'>выпускном на крыше</a>."
      }
    ],
    "cta": { "text": "Организовать выпускной", "href": "/banket" }
  },
  {
    "slug": "kuda-poyti-posle-vypusknogo-spb",
    "title": "Куда пойти после выпускного вечера в СПб",
    "metaTitle": "Куда пойти после выпускного вечера СПб 2026 | Паруса",
    "metaDescription": "Куда пойти в Петербурге после выпускного: набережная, рассвет, разводные мосты.",
    "keywords": "куда пойти после выпускного спб, после выпускного петербург, выпускной ночь петербург что делать",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/view_summer.webp",
    "lead": "Выпускной закончился — ночь только начинается. Что делать после банкета, пока светло и всё впереди?",
    "sections": [
      {
        "heading": "Петербургская традиция выпускной ночи",
        "body": "В Петербурге выпускные традиционно проходят в период белых ночей (июнь). Программа ночи: 23:00–01:00 — прогулка по набережной Невы при светлом небе. 01:15 — разводной Дворцовый мост — обязательно. 02:00–03:30 — фотосессия у Стрелки, у Петропавловской. 04:00 — рассвет над Невой. Эта ночь запоминается на всю жизнь.",
        "list": [
          "Набережная в белые ночи: идти пешком",
          "Дворцовый мост: разводка в 01:15",
          "Рассвет: встретить у Невы в 04:00",
          "Фотосессия: Стрелка В. О. — лучшее место"
        ]
      },
      {
        "heading": "Начать ночь с «Парусов»",
        "body": "Выпускной ужин в «Парусах» (ул. Марата, 5, 6 этаж) — правильный старт выпускной ночи. Банкет до 23:00, потом пешком к набережной (20 минут). Всё в центре — логистика простая. Читайте о <a href='/blog/vypusknoy-krysha-spb' class='underline text-accent'>выпускном в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Забронировать выпускной", "href": "/banket" }
  },
  {
    "slug": "banket-vypusknoy-tseny-rестораны-spb",
    "title": "Банкет на выпускной в Петербурге: цены в ресторанах",
    "metaTitle": "Банкет на выпускной — цены в ресторанах СПб 2026 | Паруса",
    "metaDescription": "Сколько стоит банкет на выпускной в ресторане Санкт-Петербурга: обзор цен в 2026 году.",
    "keywords": "банкет выпускной цены рестораны спб, сколько стоит выпускной ресторан, выпускной ресторан цена петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Сколько стоит выпускной банкет в ресторане Петербурга? Разберём реальные цифры 2026 года.",
    "sections": [
      {
        "heading": "Реальные цены на выпускной",
        "body": "Бюджетный сегмент (кафе, небольшие рестораны): 1 500–2 500 ₽/чел. Средний сегмент (рестораны с банкетным залом): 2 500–4 000 ₽/чел. Выше среднего (панорамные, популярные рестораны): 3 500–5 500 ₽/чел. Все цены включают еду, но обычно не включают алкоголь. На класс из 30 человек: 75 000–165 000 ₽ — реалистичный диапазон.",
        "list": [
          "Бюджет: 1 500–2 500 ₽/чел",
          "Средний: 2 500–4 000 ₽/чел",
          "Выше среднего: 3 500–5 500 ₽/чел",
          "Класс 30 чел: 75 000–165 000 ₽"
        ]
      },
      {
        "heading": "«Паруса» для выпускного",
        "body": "Банкетное меню «Парусов» (ул. Марата, 5) от 2 500 ₽/чел. Для класса 30 человек — от 75 000 ₽. Вид на Петербург в белые ночи — это нельзя купить дешевле, потому что этого вид не существует нигде ещё. Читайте о <a href='/blog/vypusknoy-krysha-spb' class='underline text-accent'>выпускном на крыше</a>."
      }
    ],
    "cta": { "text": "Узнать о выпускном", "href": "/banket" }
  },
  {
    "slug": "delovoy-obed-spb-rестораны-top",
    "title": "Деловой обед в СПб: лучшие рестораны",
    "metaTitle": "Деловой обед СПб — лучшие рестораны 2026 | Паруса на крыше",
    "metaDescription": "Лучшие рестораны для делового обеда в Санкт-Петербурге: где провести встречу с партнёром.",
    "keywords": "деловой обед спб рестораны, ресторан для делового обеда петербург, бизнес обед спб",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Деловой обед в Петербурге — популярный формат встречи с партнёром или клиентом. Разбираем, где лучший выбор.",
    "sections": [
      {
        "heading": "Деловой обед vs деловой ужин",
        "body": "Деловой обед: 12:00–15:00, более нейтральный по тону, подходит для рабочих встреч, скорость важна. Деловой ужин: 19:00–22:00, более неформальный, подходит для важных партнёров, предполагает алкоголь. Для первой встречи с клиентом — обед предпочтительнее: нет алкоголя, времени меньше, проще отказать от продолжения.",
        "list": [
          "Обед: нейтрально, рабочий формат",
          "Ужин: неформально, для важных отношений",
          "Первая встреча: обед безопаснее",
          "Скорость: обед требует быстрой подачи"
        ]
      },
      {
        "heading": "«Паруса» для делового обеда",
        "body": "Бизнес-ланч в «Парусах» (ул. Марата, 5) от 590 ₽ — это для индивидуального рабочего обеда. Для делового обеда с партнёром — заказ à la carte, средний чек 1 300 ₽. Вид на Петербург с 6-го этажа создаёт правильное «начало» деловой встречи. Рейтинг 5,0. Читайте о <a href='/blog/delovoy-uzhin-restoran-peterburg' class='underline text-accent'>деловом ужине</a>."
      }
    ],
    "cta": { "text": "Забронировать деловой обед", "href": "/" }
  },
  {
    "slug": "rabochiy-zavtrak-restoran-peterburg",
    "title": "Рабочий завтрак в ресторане Петербурга",
    "metaTitle": "Рабочий завтрак ресторан Петербург 2026 | Паруса на крыше",
    "metaDescription": "Где провести рабочий завтрак с партнёром в Санкт-Петербурге: рестораны, формат, советы.",
    "keywords": "рабочий завтрак ресторан петербург, деловой завтрак спб, бизнес завтрак ресторан петербург",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Рабочий завтрак — эффективный формат встречи. Утром оба свежие, нет алкоголя, встреча заканчивается органично когда начинается рабочий день.",
    "sections": [
      {
        "heading": "Преимущества рабочего завтрака",
        "body": "Обе стороны в хорошей форме: утром нет накопленной усталости дня. Нет алкоголя: чистые головы, хорошее решение. Естественный дедлайн: «надо идти на работу» — не нужно придумывать причину закончить встречу. Демонстрация уважения: ранняя встреча говорит о серьёзном отношении.",
        "list": [
          "Свежие мысли утром",
          "Без алкоголя: продуктивнее",
          "Естественный конец встречи",
          "Эффективно: за 1 час — достаточно"
        ]
      },
      {
        "heading": "Рабочий завтрак в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) предлагают завтраки. Для рабочей встречи: столик в спокойной зоне, хороший кофе, завтрак à la carte. Вид на утренний Петербург с 6-го этажа — правильный фон для встречи. Уточняйте время начала работы: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать рабочий завтрак", "href": "/" }
  },
  {
    "slug": "devichnik-s-degustatsiy-vin-restoran-spb",
    "title": "Девичник с дегустацией вин в ресторане СПб",
    "metaTitle": "Девичник с дегустацией вин СПб 2026 | Паруса на крыше",
    "metaDescription": "Девичник с дегустацией вин в ресторане Санкт-Петербурга: стильный формат для подруг невесты.",
    "keywords": "девичник дегустация вин спб, девичник вино ресторан петербург, дегустация вин девичник",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Девичник с дегустацией вин — стильный и интерактивный формат. Вместо просто «выпить и поговорить» — образовательно-развлекательный опыт с хорошим вином.",
    "sections": [
      {
        "heading": "Как устроена дегустация вин на девичнике",
        "body": "Сомелье или осведомлённый официант проводит мини-мастер-класс: 4–6 вин, каждое со своей историей, регионом, советом по сочетанию с едой. Гости пробуют, сравнивают, делятся впечатлениями. Это вовлекает всех участников, создаёт общую тему для разговора. Время: 60–90 минут на дегустацию, затем ужин.",
        "list": [
          "4–6 вин: идеально для дегустации",
          "Мини-рассказ о каждом: образовательно",
          "Сравнение: интерактивно",
          "Затем ужин: натуральный переход"
        ]
      },
      {
        "heading": "Дегустация в «Парусах»",
        "body": "В «Парусах» (ул. Марата, 5) можно организовать дегустацию вин для девичника. Широкая винная карта, обученный персонал. Уточняйте при бронировании: +7 (812) 991-10-90. Скидка 20% для виновницы торжества. Рейтинг 5,0. Читайте о <a href='/blog/devichnik-na-kryshe-peterburg' class='underline text-accent'>девичнике в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Забронировать девичник с дегустацией", "href": "/banket" }
  },
  {
    "slug": "malchishnik-s-kalyanom-restoran-spb",
    "title": "Мальчишник с кальяном в ресторане СПб",
    "metaTitle": "Мальчишник с кальяном ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Мальчишник с кальяном в ресторане Санкт-Петербурга: как организовать, где провести.",
    "keywords": "мальчишник кальян ресторан спб, кальян мальчишник петербург, мальчишник кальян спб",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Мальчишник с кальяном — популярный формат. Хорошая кухня, напитки, кальян в конце вечера — классика.",
    "sections": [
      {
        "heading": "Как сочетать ужин и кальян",
        "body": "Правильный порядок: сначала ужин, потом кальян. Кальян после еды, не до — желудок готов, атмосфера расслаблена. Мясо на хоспере, хорошее вино или крепкое, потом кальян под разговор. Это ненапряжённый формат для компании от 6 до 15 человек.",
        "list": [
          "Ужин: сначала, кальян после",
          "Компания: 6–15 человек оптимально",
          "Мясо на хоспере: хороший центр ужина",
          "Кальян: финальный акт вечера"
        ]
      },
      {
        "heading": "Кальян в «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) предлагают кальян как дополнительную услугу. Ужин на хоспере + виды на ночной Петербург + кальян = правильный мальчишник. Уточняйте наличие и условия кальяна при бронировании: +7 (812) 991-10-90. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать мальчишник", "href": "/banket" }
  },
  {
    "slug": "biznes-peregovory-restoran-spb-top",
    "title": "Рестораны для бизнес-переговоров в СПб",
    "metaTitle": "Рестораны для бизнес-переговоров СПб 2026 | Паруса",
    "metaDescription": "Лучшие рестораны для бизнес-переговоров в Санкт-Петербурге: приватность, уровень, сервис.",
    "keywords": "рестораны бизнес переговоры спб, ресторан для переговоров петербург, переговорный ресторан спб",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Бизнес-переговоры в ресторане — когда важны три вещи: приватность, статус места, хорошая еда. Разберём, как выбрать правильный ресторан.",
    "sections": [
      {
        "heading": "Критерии переговорного ресторана",
        "body": "Статус: место должно говорить о серьёзности ваших намерений. Слишком дешёвое — неуважение. Слишком пафосное — выглядит как показуха. Тишина: деловой разговор требует слышать друг друга. Приватность: столик в стороне или отдельная зона. Сервис: профессиональный, не навязчивый.",
        "list": [
          "Статус соответствует встрече",
          "Тишина: слышать друг друга",
          "Приватность: в стороне от зала",
          "Сервис: деловой, ненавязчивый"
        ]
      },
      {
        "heading": "«Паруса» для переговоров",
        "body": "Средний чек 1 300 ₽ — достаточно высокий для серьёзности, но не чрезмерный. Вид создаёт разговорный старт. Будние дни — тихо. Приватные зоны по запросу. Рейтинг 5,0. Телефон: +7 (812) 991-10-90. Читайте о <a href='/blog/delovoy-uzhin-restoran-peterburg' class='underline text-accent'>деловых встречах</a>."
      }
    ],
    "cta": { "text": "Забронировать для переговоров", "href": "/" }
  },
  {
    "slug": "luchshiy-restoran-yubiley-peterburg-top",
    "title": "Лучшие рестораны для юбилея в Петербурге: топ",
    "metaTitle": "Лучшие рестораны для юбилея Петербург 2026 | Паруса",
    "metaDescription": "Топ лучших ресторанов для юбилея в Санкт-Петербурге: атмосфера, вместимость, цены.",
    "keywords": "лучшие рестораны юбилей петербург, ресторан на юбилей спб топ, ресторан юбилей петербург лучший",
    "date": "2026-06-09",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Юбилей заслуживает лучшего места в городе. Собрали ключевые критерии и топ-выбор для особой даты.",
    "sections": [
      {
        "heading": "Что делает ресторан лучшим для юбилея",
        "body": "Атмосфера: место должно создавать ощущение особого события. Кухня: уровень выше обычного — юбилей не случается каждый день. Вместимость: от 15 до 300 гостей — в зависимости от масштаба. Репутация: рейтинг и опыт юбилеев говорят сами за себя. Сервис: менеджер мероприятий = спокойствие организатора.",
        "list": [
          "Атмосфера: место само по себе праздник",
          "Кухня: выше обычного уровня",
          "Вместимость: от 15 до 300+",
          "Репутация: рейтинг и отзывы"
        ]
      },
      {
        "heading": "«Паруса» — выбор для юбилея",
        "body": "Рейтинг 5,0 при 2 606 отзывах. «Хорошее место 2026». С 2009 года — сотни юбилеев. Вид на Петербург с 6-го этажа. Банкетное меню от 2 500 ₽/чел. Скидка 20% именинникам. Зал до 300 гостей. Менеджер мероприятий. Читайте о <a href='/blog/luchshie-restorany-dlya-yubiley-peterburg' class='underline text-accent'>ресторанах для юбилея</a>."
      }
    ],
    "cta": { "text": "Забронировать юбилей", "href": "/banket" }
  }
];
